import { Outlet } from 'react-router';

import useAuth from 'portal/src/auth/useAuth';
import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';
import forbiddenResponse from 'portal/src/navigation/responses/forbiddenResponse';

import { isBillAutomationTableEnabled } from './billAutomationEnabled';

export default function BillAutomationTableWithForm() {
  const { featureChecker, hasReadOnlyAccess } = useAuth();

  if (
    !isBillAutomationTableEnabled({
      featureChecker,
      hasReadOnlyAccess,
    } as IAuthorizationContext)
  ) {
    throw forbiddenResponse();
  }

  return <Outlet />;
}
